import { Component, OnInit, OnDestroy, ViewChild, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ServerService } from '../service/server/server.service';

@Component({
  selector: 'app-shop-service',
  templateUrl: './shop-service.component.html',
  styleUrls: ['./shop-service.component.scss']
})
export class ShopServiceComponent implements OnInit, OnDestroy {
  public isOnline: any;
  public loading = false;
  public subscription: Subscription;
  public err: string; public err_validation: boolean = false;
  public err_internet_text: string; public err_internet_validation: boolean;
  public server: any;
  title: string;
  lang: any;
  id: number;
  list_record: any = [];
  table: any;
  user_info: any;
  user_id: number;
  row_id: any;

  mat_table_selectedRow: any;
  dataSource;
  displayedColumns = ['row', 'title'];

  where: any;


  constructor(public serverService: ServerService, public router: Router, public matSnackBar: MatSnackBar
    , private matDialogRef: MatDialogRef<ShopServiceComponent>
    , @Inject(MAT_DIALOG_DATA) public dialog_data: any) {
    this.id = dialog_data.id;
  }//end consructor

  ngOnInit() {
    this.server = this.serverService.get_server();
    this.lang = <any>localStorage.getItem('lang');
    this.user_info = JSON.parse(<any>localStorage.getItem("user_info"));
    this.user_id = this.user_info.user_id;
    this.get_service();
  }

  get_service() {
    if (this.serverService.check_internet()['status'] == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_erorr(true, 'Erorr in Intentet', pe_message, 1, 'close', pe_action);
      return;
    }//end if 
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { 'address': 255, id: this.id }).subscribe(
      (res) => {
        this.list_record = [];
        if (res['status'] == 1 && res['num'] > 0) {
          this.title = res['result'][0].shop_services_title;
          this.table = res['result'][0].shop_services_table;
          this.where = res['result'][0].shop_services_where;
          this.get_data();

          this.recieve_erorr(false, "", "", 1, "", "");
        }//end if 
        else if (res['status'] == 1 && res['num'] == 0) {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_erorr(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_erorr(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  get_bg(row_id) {
    this.row_id = row_id;
  }

  arrowDownEvent() {
    console.log(1);
    //this.row_id = row_id;
  }

  get_data() {
    if (this.serverService.check_internet()['status'] == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_erorr(true, 'Erorr in Intentet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { 'address': 254, id: this.id, table: this.table, where1: this.where }).subscribe(
      (res) => {
        this.list_record = [];
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            this.list_record.push(res['result'][i]);
          }//end for
          this.dataSource = new MatTableDataSource(this.list_record);
          this.recieve_erorr(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_erorr(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }//end recieve_data

  select(id, title) {
    this.matDialogRef.close({ id: id, title: title });
  }//end select

  close() {
    this.matDialogRef.close();
  }

  //**************************************************
  recieve_erorr(validation, en_message, pe_message, type, en_action, pe_action) {
    this.err_internet_validation = false;
    if (type == 1) this.loading = false;
    if (validation == true) {
      if (this.lang == 1) this.matSnackBar.open(pe_message, pe_action, { duration: 2000 });
      if (this.lang == 2) this.matSnackBar.open(en_message, en_action, { duration: 2000 });
    }//end if
    else {
      this.matSnackBar.dismiss();
    }
  }
  //*******************************************************************************
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }//end if
  }//end OnDestroy
} 